import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import clsx from 'clsx';

import styles from '@/modules/homepage/CompanyWebsites/CompanyWebsites.module.css';
import { WebsiteInterface } from '@/types/homepage.types';

export interface CompanyWebsitesProps {
  title?: string;
  data: WebsiteInterface[];
}

export const CompanyWebsites = ({ data, title }: CompanyWebsitesProps) => {
  const wrapperClasses = clsx(styles.wrapper);
  const headerClasses = clsx(styles.header);
  const linkClasses = clsx(styles.link);
  const imageContainerClasses = clsx(styles.image__container);
  const imageWrapperClasses = clsx(styles.image__wrapper);
  const imageClasses = clsx(styles.image);
  const nameClasses = clsx(styles.name);
  const borderContainerClasses = clsx(styles.border__container);
  const borderClasses = clsx(styles.border);

  return (
    <div className={wrapperClasses}>
      <h2 className={headerClasses}>{title || 'Our Sites'}</h2>
      <ul>
        {data.map((dataObject, index) => {
          return (
            <li key={dataObject.name}>
              <a
                className={linkClasses}
                href={dataObject.link}
                rel='noopener noreferrer'
                target='_blank'
                aria-label={`Link to ${dataObject.name} website (opens in a new tab)`}
              >
                <div className={imageContainerClasses}>
                  <div className={imageWrapperClasses}>
                    <img
                      className={imageClasses}
                      src={getCDNURL(dataObject.image, 20, 20)}
                      alt=''
                    />
                  </div>
                  <div className={nameClasses}>{dataObject.name}</div>
                </div>
              </a>
              {index !== data.length - 1 && (
                <div className={borderContainerClasses}>
                  <div className={borderClasses} />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
